module.exports = __webpack_public_path__ + "img/hr-dry-tree-00.f586de5b.png";